import { useTranslation } from 'react-i18next';

export default function NicheExamples() {
  const { t } = useTranslation();

  const niches = [
    {
      icon: '🎨',
      name: t('landing.niches.n1name', { defaultValue: 'Content Creator' }),
      bio: t('landing.niches.n1bio', { defaultValue: '✦ Creating what I wish existed\nStorytelling through visuals & vibes\n📍 LA | New content every week\n↓ Free preset pack' }),
      caption: t('landing.niches.n1cap', { defaultValue: 'The secret nobody tells you about growing on Instagram: consistency beats perfection every single time.' }),
    },
    {
      icon: '💄',
      name: t('landing.niches.n2name', { defaultValue: 'Beauty & Skincare' }),
      bio: t('landing.niches.n2bio', { defaultValue: '✦ Licensed esthetician · Clean beauty\nSimplifying your routine, one product at a time\n🧴 Honest reviews only\n↓ My top 10 under $30' }),
      caption: t('landing.niches.n2cap', { defaultValue: 'Your skin barrier called — it wants you to stop using 12 products. Here\'s the 3-step routine that actually works.' }),
    },
    {
      icon: '🏪',
      name: t('landing.niches.n3name', { defaultValue: 'Small Business' }),
      bio: t('landing.niches.n3bio', { defaultValue: '✦ Handcrafted candles for intentional living\nSmall-batch · Sustainable · Made in Portland\n🕯️ New scents monthly\n↓ Shop the collection' }),
      caption: t('landing.niches.n3cap', { defaultValue: 'Behind every candle is 47 failed batches and a stubborn belief that scent can change how a room feels.' }),
    },
    {
      icon: '📱',
      name: t('landing.niches.n4name', { defaultValue: 'Social Media Manager' }),
      bio: t('landing.niches.n4bio', { defaultValue: '✦ Social media strategist for growing brands\n10+ accounts · 3M+ reach generated\n📊 Data-driven, story-first\n↓ Free content calendar' }),
      caption: t('landing.niches.n4cap', { defaultValue: 'I manage 10 accounts and here\'s what I\'ve learned: the brands that win aren\'t posting more — they\'re posting smarter.' }),
    },
  ];

  return (
    <section id="niche-examples" className="niches-section">
      <div className="section-label">
        {t('landing.niches.label', { defaultValue: 'For Every Niche' })}
      </div>
      <h2 className="section-title">
        {t('landing.niches.title1', { defaultValue: 'Built for ' })}
        <em>{t('landing.niches.title2', { defaultValue: 'your' })}</em>
        {t('landing.niches.title3', { defaultValue: ' kind of content' })}
      </h2>
      <p className="section-sub">
        {t('landing.niches.sub', { defaultValue: 'CaptionScript adapts to your niche, tone, and audience — not the other way around.' })}
      </p>

      <div className="niches-grid">
        {niches.map((niche, i) => (
          <div key={i} className="niche-card">
            <div className="niche-header">
              <span className="niche-icon">{niche.icon}</span>
              <span className="niche-name">{niche.name}</span>
            </div>
            <div className="niche-preview">
              <div className="niche-block">
                <div className="niche-block-label">{t('landing.niches.bioLabel', { defaultValue: 'Bio' })}</div>
                <div className="niche-block-text">{niche.bio}</div>
              </div>
              <div className="niche-block">
                <div className="niche-block-label">{t('landing.niches.capLabel', { defaultValue: 'Caption' })}</div>
                <div className="niche-block-text">{niche.caption}</div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
